import { createSlice } from "@reduxjs/toolkit";

const initialState = { themes: [] };

// eslint-disable-next-line import/prefer-default-export
export const surveyThemesSlice = createSlice({
  name: "surveyThemes",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setSurveyThemes: (state, action) => action.payload,
  },
});

export const { setSurveyThemes } = surveyThemesSlice.actions;

export default surveyThemesSlice.reducer;

export const selectSurveyThemes = (state) => state.surveyThemes;
